import { Box, Typography } from "@material-ui/core";
import { ContentState, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import React, { useEffect, useState, forwardRef } from "react";
import CustomEditor from "../../components/Editor";
import styled from "styled-components/macro";

const StyledTypographyWrapper = styled(Box)`
  display: flex;
  justify-content: center;
`;
const StyledTypography = styled(Typography)`
  text-decoration: underline;
`;
function ApplicationInfo({ title, info }) {
  const [editorState, setEditorState] = useState("");

  useEffect(() => {
    setEditorState(() => {
      let contentBlock = null;
      if (info) {
        contentBlock = htmlToDraft(info);
      }
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const newEditorState = EditorState.createWithContent(contentState);
        return newEditorState;
      }
    });
  }, [info]);
  return (
    <>
      <StyledTypography variant="h3" id={title} style={{ margin: "4rem 0" }} />
      <StyledTypographyWrapper>
        <StyledTypography variant="h3" style={{ margin: "4rem 0 0 0" }}>
          {title}
        </StyledTypography>
      </StyledTypographyWrapper>
      <CustomEditor toolbarHidden readOnly editorState={editorState} />
    </>
  );
}

export default ApplicationInfo;
